/*
 * @Author: yzr
 * @Date: 2020-11-30 09:46:47
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-30 09:57:16
 */
import SelesArea from './area_select.vue';

export default SelesArea;
